import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck, Users } from "lucide-react";
import useHasDirectoryListing from "../../hooks/useHasDirectoryListing";

const ROTATING_WORDS = ["Arguments.", "Briefs.", "Case Strategy.", "Research."];

export default function NewLandingHero() {
  const hasDirectoryListing = useHasDirectoryListing();
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setWordIndex((i) => (i + 1) % ROTATING_WORDS.length),
      2200,
    );
    return () => clearInterval(id);
  }, []);

  const scrollToModes = () => {
    document.getElementById("mode-section")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <section className="hero">
        <div className="hero-bg" aria-hidden="true">
          <div className="hero-orb hero-orb-1" />
          <div className="hero-orb hero-orb-2" />
          <div className="hero-grid-overlay" />
        </div>
        <div className="hero-inner">
          <motion.h1
            className="headline"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <span className="headline-stack">
              <span className="headline-line">Outmaneuver Opposing Counsel</span>
              <span className="headline-line headline-line-rotate">
                <span className="headline-prefix">With Stronger</span>
                <span className="rotating-wrapper" aria-live="polite">
                  <AnimatePresence mode="wait">
                    <motion.span
                      key={ROTATING_WORDS[wordIndex]}
                      className="rotating-word"
                      initial={{ rotateX: 90, opacity: 0, y: 15 }}
                      animate={{ rotateX: 0, opacity: 1, y: 0 }}
                      exit={{ rotateX: -90, opacity: 0, y: -15 }}
                      transition={{ duration: 0.35, ease: "easeInOut" }}
                    >
                      {ROTATING_WORDS[wordIndex]}
                    </motion.span>
                  </AnimatePresence>
                </span>
              </span>
            </span>
          </motion.h1>
          <motion.p
            className="subheadline"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            LawFusion runs your legal questions, briefs, and case strategy through
            multiple AIs — comparing analysis, debating arguments, exposing weak
            spots, and helping you get ahead of opposing counsel.
          </motion.p>
          <motion.div
            className="guarantee"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <ShieldCheck size={16} strokeWidth={2.5} aria-hidden="true" />
            Guaranteed to strengthen your argument — or your money back.
          </motion.div>
          <motion.div
            className="cta-group"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.35 }}
          >
            <button type="button" className="btn-primary nl-btn-unstyled" onClick={scrollToModes}>
              See How It Works — Then Try It Free →
            </button>
            {/* Under the primary CTA at every width. It started phone-only
                (the directory hides behind the hamburger there), but the
                stakeholder wants attorneys who came for the listing to see the
                way in on desktop as well (QA #11).

                Hidden once the visitor has a listing — the invitation has been
                accepted. "My Directory Listing" stays in the header, so the
                way back to their listing is not lost. */}
            {!hasDirectoryListing && (
              <Link to="/directory" className="btn-directory-mobile">
                <Users size={17} strokeWidth={2.2} aria-hidden="true" />
                Join the Free Attorney Directory →
              </Link>
            )}
          </motion.div>
        </div>
      </section>
      <div className="section-divider" />
    </>
  );
}
